(function (angular) {
	angular.module('bizPartEngage').controller('core.terms.show', showTermsController);

	showTermsController.$inject = ["core.terms.service"];

	function showTermsController(termsService) {
		var vm = this;
		vm.GetTerms = GetTerms;

		function GetTerms() {
			vm.GettingsTerms = true;
			termsService.GetSystemTerms().then(GetTermsCallback);

			function GetTermsCallback(response) {
				vm.GettingsTerms = false;
				var terms = BizPartCoreHelpers.getResponseValue(response, []);
				for (var i = 0; i < terms.length; i++)
					terms[i].InteractionsDisabled = true;

				vm.Terms = terms;
			}
		}

		vm.GetTerms();
	}
}(window.angular));